import React from "react"
import ModalV4 from "../../../../app/ui/modal/v4/v4"

import Event from "../../../model2/event/event"
import EventFinder from "../../../gd-components/finder/event/event-finder";

type Props = {
    params: {
        projectId           : ID

        onSubmit            : {(item:any):void}
    }
}

export default class ModalEventLink extends ModalV4 {

    onClickEvent = (event: Event) => {
        if (this.props.params.onSubmit) this.props.params.onSubmit({id: event.id, name: event.name, type: 'event', data:event})
    }

    render() {
        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                <EventFinder parentProjectId    = {this.props.params.projectId}
                             onClickEvent       = {this.onClickEvent}
                             onClose            = {this.closeModal}/>
            </div>
        );
    }
}